export {
  JargonHubFeature as default,
  getStaticProps,
} from '@cinch-nx/landing-feature-jargon-hub'
